import { render, staticRenderFns } from "./Table4.vue?vue&type=template&id=b2443590&scoped=true&"
import script from "./Table4.vue?vue&type=script&lang=js&"
export * from "./Table4.vue?vue&type=script&lang=js&"
import style0 from "./Table4.vue?vue&type=style&index=0&id=b2443590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2443590",
  null
  
)

export default component.exports